export const commonEn = {
  common: {
    save: "Save",
    cancel: "Cancel",
    download: "Download",
    loading: "Loading...",
    goBack: "Go Back",
    selectParcel: "Select a parcel",
    noData: "No data available",
    error: "Error",
    success: "Success",
    generate: "Generate",
    update: "Update",
    configuration: "Configuration",
    search: "Search",
    filter: "Filter",
    export: "Export",
    import: "Import",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    add: "Add",
    close: "Close",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    hectares: "ha",
    area: "Area",
    date: "Date",
    status: "Status",
    actions: "Actions",
    details: "Details",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    total: "Total",
    average: "Average",
    signedOut: "Signed out",
    signedOutDesc: "You have been successfully signed out",
    signOutError: "Failed to sign out"
  },
  nav: {
    home: "Home",
    dashboard: "Dashboard",
    parcels: "Parcels",
    frostProtection: "Frost Protection",
    settings: "Settings",
    logout: "Log Out",
    signIn: "Sign In",
    signUp: "Sign Up",
    signOut: "Sign Out",
    getStarted: "Get Started",
    features: "Features",
    pricing: "Pricing",
    about: "About",
    contact: "Contact",
    solutions: "Solutions",
    blog: "Blog",
    insuranceCompany: "Insurance Company",
    installApp: "Install App",
    bookDemo: "Book a demo"
  },
  sidebar: {
    myFarm: "MY FARM",
    cooperative: "COOPERATIVE",
    summary: "SUMMARY",
    management: "MANAGEMENT",
    toolsAndAnalytics: "TOOLS & ANALYTICS",
    satelliteImages: "SATELLITE IMAGES",
    irrigationFertilization: "IRRIGATION & FERTILIZATION",
    analyticsReports: "ANALYTICS & REPORTS",
    marketIntelligence: "MARKET INTELLIGENCE",
    academicTools: "ACADEMIC TOOLS",
    dashboard: "DASHBOARD",
    overview: "Overview",
    alerts: "Alerts",
    fireDetection: "Fire Detection",
    calendar: "Calendar",
    seasons: "Seasons",
    performanceRankings: "Performance Rankings",
    members: "Members",
    myParcels: "MY PARCELS",
    manageParcels: "Manage Parcels",
    fieldNotebook: "Field Notebook",
    cropResources: "Crop Resources",
    viewImages: "View Images",
    vegetationIndices: "Vegetation Indices",
    advancedAnalysis: "Agronomy Tools",
    splitView: "Split View",
    ndviZones: "NDVI Zones",
    irrigation: "Irrigation",
    pkOptimizer: "P&K Optimizer",
    nitrogenOptimizer: "Nitrogen Optimizer",
    pestsDiseases: "Pests & Diseases",
    satelliteIntelligence: "Satellite Intelligence",
    soilFertility: "Soil & Fertility",
    irrigationWater: "Irrigation & Water",
    irrigationOptimizer: "Irrigation Optimizer",
    riskAlerts: "Risk & Alerts",
    reportsEvidence: "Reports & Evidence",
    resources: "Resources",
    parcelsGroup: "Parcels",
    brandTagline: "Farm Intelligence Platform",
    basicAnalytics: "Basic Analytics",
    aiInsights: "AI Insights",
    intelligentFarming: "Intelligent Farming",
    riskAnalysisMl: "Risk Analysis ML",
    reportsCenter: "Reports Center",
    verifiedFarm: "Verified Farm",
    insurance: "Insurance",
    marketplace: "Marketplace",
    marketPrices: "Market Prices",
    priceTrends: "Price Trends",
    regionalAnalysis: "Regional Analysis",
    marketAnalytics: "Market Analytics",
    commerce: "COMMERCE",
    productMarketplace: "Product Marketplace",
    prefinancing: "Prefinancing & Factoring",
    creditScoring: "Credit Scoring",
    parametricInsurance: "Parametric Insurance",
    certifiedMarketplace: "Certified Marketplace",
    userManual: "User Manual",
    irrigationReports: "Irrigation Reports",
    copernicusData: "Copernicus Data",
    groundTruthValidation: "Field Observations",
    phenology: "Phenology Intelligence",
    supportTickets: "Support Tickets",
    learningHub: "🎮 Learning Hub",
    signOut: "Sign Out",
    signedOut: "Signed out",
    signedOutDesc: "You have been successfully signed out",
    errorSigningOut: "Failed to sign out",
    parcelPassport: "Digital Passport",
    epidemiologicalRisk: "Epidemiological Risk",
    machineryImport: "Machinery Data Import",
    golfCourse: "Golf Course Management",
    vraShapefileBuilder: "VRA Shapefile Builder",
    aiCropClassification: "AI Crop Classification",
    agBusinessMultiAdvisor: "AgBusiness (Multi-Advisor)",
    firePropagation: "Fire Propagation",
    multiFarmOverview: "Multi-Farm Overview",
    parcels: "Parcels",
    analytics: "Analytics",
    satellite: "Satellite",
    settings: "Settings",
    insuranceDashboard: "Insurance Dashboard",
    greenSpaces: "Green Spaces"
    ,
    weatherConditions: "Weather & Conditions",
    economicRiskImpact: "Economic Risk Impact",
    harvestValueEstimator: "Harvest Value Estimator",
    pacPreCompliance: "Compliance Readiness Check",
    digitalParcelRecord: "Digital Parcel Record",
    settingsGroup: "Settings",
    helpSupport: "Help & Support",
    adminTools: "Admin Tools",
    droughtWaterStress: "Drought & Water Stress",
    floodRisk: "Flood Risk",
    pestDiseaseRisk: "Pest & Disease Risk",
    epidemiologicalRisk2: "Epidemiological Risk Map",
    agronomicRiskAssessment: "Agronomic Risk Assessment",
    vraExports: "Yield-to-VRA Builder",
    verifiedFarmBeta: "Verified Farm",
    integrations: "Integrations",
    groupDashboard: "Dashboard",
    groupParcel: "Parcel",
    groupMonitor: "Monitor",
    groupRisk: "Risk",
    groupDecide: "Decide",
    groupReport: "Report",
    groupProve: "Prove",
    foliarAnalysis: "Foliar Analysis",
    agronomyTools: "Agronomy Tools"
  },
  multiFarm: {
    title: "Multi-Farm Overview",
    subtitle: "Monitor all your parcels at a glance — designed for technicians managing multiple farms",
    refresh: "Refresh",
    totalParcels: "Total Parcels",
    avgNdvi: "Avg. NDVI",
    highRisk: "High Risk",
    activeAlerts: "Active Alerts",
    allClear: "All clear",
    needsAttention: "Need attention",
    unread: "Unread",
    searchPlaceholder: "Search by name or crop...",
    sortRisk: "Risk",
    sortArea: "Area",
    noParcels: "No parcels found",
    noResults: "No parcels match your search",
    addParcelsFirst: "Add parcels in the Management section to get started",
    colParcel: "Parcel",
    colCrop: "Crop",
    colArea: "Area",
    colRisk: "Risk",
    colAlerts: "Alerts",
    colTemp: "Temp",
    colWater: "Water",
    colAction: "Action",
    view: "View",
    excellent: "Excellent",
    good: "Good",
    fair: "Fair",
    poor: "Poor",
    critical: "Critical",
    high: "High",
    medium: "Medium",
    low: "Low",
    unnamedParcel: "Unnamed Parcel",
    footerInfo: "Data from latest satellite analysis and weather providers. Click any row to see full details."
  },
  auth: {
    signIn: "Sign In",
    signUp: "Sign Up",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    rememberMe: "Remember me",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    createAccount: "Create Account",
    resetPassword: "Reset Password",
    sendResetLink: "Send Reset Link",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone Number",
    farmName: "Farm Name",
    termsAgree: "I agree to the Terms of Service and Privacy Policy"
  },
  settings: {
    title: "Settings",
    subtitle: "Manage your account and preferences",
    profile: "Profile",
    notifications: "Notifications",
    preferences: "Preferences",
    security: "Security",
    billing: "Billing",
    language: "Language",
    timezone: "Timezone",
    units: "Units",
    metric: "Metric",
    imperial: "Imperial",
    emailNotifications: "Email Notifications",
    smsNotifications: "SMS Notifications",
    pushNotifications: "Push Notifications",
    saveChanges: "Save Changes",
    changePassword: "Change Password",
    twoFactor: "Two-Factor Authentication",
    deleteAccount: "Delete Account"
  },
  footer: {
    company: "Company",
    aboutUs: "About Us",
    careers: "Careers",
    press: "Press",
    blog: "Blog",
    product: "Product",
    features: "Features",
    pricing: "Pricing",
    integrations: "Integrations",
    api: "API",
    support: "Support",
    helpCenter: "Help Center",
    documentation: "Documentation",
    contactUs: "Contact Us",
    status: "Status",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    cookies: "Cookie Policy",
    copyright: "© 2026 Sentinel Crop. Sentinel Crop® is a registered trademark of Astranova Consultoría Avanzada S.L.U. All rights reserved."
  }
};
